import {CloudProvider, CloudProvidersService} from "app/services/domain/cloud-providers.service";
import * as Models from "app/services/proxy/model/models";
import {MomentHelper} from "framework/ui/formatting/date-format.pipe";

export function formatUpdatedOn(updatedOn: string | Date): { formattedTime: string, formattedDate: string, timeAgo: string }
{
    if (!updatedOn)
    {
        return {
            formattedTime: "",
            formattedDate: "",
            timeAgo      : ""
        };
    }

    // Parse the date using MomentHelper
    const date = MomentHelper.parse(updatedOn);

    // Format the time and date
    const formattedTime = date.format("hh:mm a"); // 12-hour format with am/pm
    const formattedDate = date.format("MM/DD/YYYY"); // Date in MM/DD/YYYY format

    // Calculate the relative time
    const timeAgo = MomentHelper.parse(updatedOn)
                                .from(MomentHelper.now()); // e.g., "12 hours ago"

    return {
        formattedTime,
        formattedDate,
        timeAgo
    };
}

// Parses as UTC by default to standardize the displayed date format
export function getFormattedMonthYear(dateString: string | Date,
                                      parseAsUTC: boolean = true): string
{
    const parser = parseAsUTC ? MomentHelper.parseAsUTC : MomentHelper.parse;
    return parser(dateString)
        .format("MMM. YYYY");
}

export function defaultChargeTypeQuery(provider: Models.CloudServiceName): Models.BillingLineItemTypeQueryOperator
{
    let cloud           = CloudProvidersService.toCloudProvider(provider);
    let types: string[] = null;

    if (CloudProvidersService.isCloudProvider(cloud))
    {
        switch (cloud)
        {
            case CloudProvider.Azure:
            case CloudProvider.OCI:
                types = ["Usage"];
                break;

            case CloudProvider.AWS:
                types = [
                    "Usage",
                    "DiscountedUsage"
                ];
                break;

            case CloudProvider.GCP:
                types = ["regular"];
                break;
        }
    }

    return Models.BillingLineItemTypeQueryOperator.newInstance({line_item_types: types});
}
